"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_OP = function NO_OP() {};

var CustomModal = function CustomModal(_ref) {
  var shown = _ref.shown,
      _ref$setShown = _ref.setShown,
      setShown = _ref$setShown === void 0 ? NO_OP : _ref$setShown,
      title = _ref.title,
      _onOk = _ref.onOk,
      children = _ref.children,
      okText = _ref.okText,
      cancelText = _ref.cancelText,
      footer = _ref.footer,
      width = _ref.width,
      _ref$onCancel = _ref.onCancel,
      _onCancel = _ref$onCancel === void 0 ? NO_OP : _ref$onCancel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$destroyOnClose = _ref.destroyOnClose,
      destroyOnClose = _ref$destroyOnClose === void 0 ? true : _ref$destroyOnClose;

  return /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    className: "CustomModal ".concat(className),
    title: title,
    visible: shown,
    onOk: function onOk() {
      return _onOk();
    },
    onCancel: function onCancel() {
      _onCancel();

      setShown(false);
    },
    closeIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: "/images/assets/cross.svg",
      alt: ""
    }),
    okText: okText,
    cancelText: cancelText,
    footer: footer,
    width: width,
    centered: true,
    destroyOnClose: destroyOnClose
  }, children);
};

var _default = CustomModal;
exports.default = _default;